import { useEffect } from 'react';

const SITE = '다잇';
const ORIGIN = 'https://www.da-eat.com';
const DEFAULT_DESC = '음식의 모든 것을 잇다, 다잇';
const DEFAULT_IMAGE = `${ORIGIN}/daeat_og_1200x630.png`;

function setTag(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [, key, name] = selector.match(/\[(\w+)="([^"]+)"\]/) ?? [];
    if (key && name) el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * 페이지별 title · description · OG 태그.
 *
 * CRA(SPA)라 index.html의 태그 하나를 모든 라우트가 공유한다.
 * 그대로 두면 186개 체험단 상세가 전부 같은 제목·설명·썸네일로 공유된다.
 * react-helmet도 결국 런타임에 DOM을 고치므로, 의존성 없이 같은 일을 한다.
 *
 * @param {{title?: string, description?: string, image?: string, noIndex?: boolean}} meta
 */
export function useDocumentMeta({ title, description, image, noIndex = false } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : SITE;
    const desc = description || DEFAULT_DESC;
    const img = image || DEFAULT_IMAGE;
    const url = `${ORIGIN}${window.location.pathname}`;

    document.title = fullTitle;
    setTag('meta[name="description"]', 'content', desc);
    setTag('meta[property="og:title"]', 'content', fullTitle);
    setTag('meta[property="og:description"]', 'content', desc);
    setTag('meta[property="og:image"]', 'content', img);
    setTag('meta[property="og:url"]', 'content', url);
    setTag('meta[name="twitter:image"]', 'content', img);
    setTag('meta[name="robots"]', 'content', noIndex ? 'noindex, follow' : 'index, follow');
    setCanonical(url);
  }, [title, description, image, noIndex]);
}
